import * as React from "react";
const SvgFiRrBikingMountain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-biking-mountain_svg__a)">
      <path
        fill="#062147"
        d="M5 13a5 5 0 1 0 0 9.999A5 5 0 0 0 5 13m0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6m14-8a4.999 4.999 0 1 0 0 9.998A4.999 4.999 0 0 0 19 13m0 8a3 3 0 1 1 0-5.999A3 3 0 0 1 19 21m-8.636-9.723a.99.99 0 0 1-.051-1.457c.169-.16 2.653-2.44 2.653-2.44l3.327 3.327a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-.124-.107A6.45 6.45 0 0 0 9.923 4C8.521 4 5 5.19 5 8a3 3 0 0 0 3 3c.024 0 .046-.005.069-.006a3 3 0 0 0 .993 1.8L11 14.459V18a1 1 0 0 0 2 0v-4a1 1 0 0 0-.349-.759zM7 8c0-1.214 2.172-2 2.923-2 .456.002.908.08 1.339.227l-2.343 2.16C8.538 8.749 8.225 9 8 9a1 1 0 0 1-1-1m7-5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-biking-mountain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBikingMountain;
